var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5119_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1999 7.07004L10.2499 11L12.4999 14C12.8299 14.44 12.7399 15.07 12.2999 15.4C11.8599 15.73 11.2299 15.65 10.8999 15.2C9.84993 13.8 8.58993 12.13 7.79993 11.06C7.39993 10.53 6.59993 10.53 6.19993 11.06L2.19993 16.39C1.70993 17.06 2.17993 18 2.99993 18H20.9999C21.8199 18 22.2899 17.06 21.7999 16.4L14.7999 7.07004C14.3999 6.53004 13.5999 6.53004 13.1999 7.07004V7.07004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5119_466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.9e1aa170b1f080cb4b0d66c91c0cf678.svg";
export { ForwardRef as ReactComponent };